import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import SelectAsync from 'react-select/async';

export default class User extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            password: '',
            selectedLevel: this.getDefaultGuid(),
            selectedAffiliateMarketingPlan: this.getDefaultGuid(),
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/user/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            this.state.data = data;

            if (data.status === 1) {

                if (this.isBlank(this.state.data.record.educations)) this.state.data.record.educations = "[]";
                if (this.isBlank(this.state.data.record.jobs)) this.state.data.record.jobs = "[]";
                if (this.isBlank(this.state.data.record.rewards)) this.state.data.record.rewards = "[]";

                this.state.data.record.educations = JSON.parse(this.state.data.record.educations);
                this.state.data.record.jobs = JSON.parse(this.state.data.record.jobs);
                this.state.data.record.rewards = JSON.parse(this.state.data.record.rewards);

                this.setState({
                    skills: data.skills,
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {    
        e.preventDefault();
        if (this.isBlank(this.state.data.record.cooperationType)) this.state.data.record.cooperationType = 0;
        if (this.isBlank(this.state.data.record.provinceId)) this.state.data.record.provinceId = 0;
        if (this.isBlank(this.state.data.record.cityId)) this.state.data.record.cityId = 0;
        if (this.isBlank(this.state.data.record.gender)) this.state.data.record.gender = 0;
        if (this.isBlank(this.state.data.record.education)) this.state.data.record.education = 0;
        if (this.isBlank(this.state.data.record.commissionPercent)) this.state.data.record.commissionPercent = 0;
        
        this.httpPost("api/v1/user/save", {
            id: this.getCurrentFormId(),
            fname: this.state.data.record.fname,
            lname: this.state.data.record.lname,
            mobile: this.state.data.record.mobile,
            password: this.state.password,
            status: this.state.data.record.status,
            nationalId: this.state.data.record.nationalId,
            role: this.state.data.record.role,
            role2: this.state.data.record.role2,
            blueTick: this.state.data.record.blueTick,   
            
            commissionPercent: parseInt(this.state.data.record.commissionPercent),
            cooperationType: this.state.data.record.cooperationType,
            aboutMe: this.state.data.record.aboutMe,
            jobs: JSON.stringify(this.state.data.record.jobs),
            educations: JSON.stringify(this.state.data.record.educations),
            rewards: JSON.stringify(this.state.data.record.rewards),
            resumeDisplayStatus: this.state.data.record.resumeDisplayStatus,
            education: this.state.data.record.education,
            gender: this.state.data.record.gender,
            aff: this.state.data.record.aff,
            counselingOnline: this.state.data.record.counselingOnline,
            counselingOnlinePrice: this.state.data.record.counselingOnlinePrice,
            counselingPhone: this.state.data.record.counselingPhone,
            counselingPhonePrice: this.state.data.record.counselingPhonePrice,
            counselingPhonePrice2: this.state.data.record.counselingPhonePrice2,
            counselingPhonePrice3: this.state.data.record.counselingPhonePrice3,
            provinceId: this.state.data.record.provinceId,
            cityId: this.state.data.record.cityId,
            skills: this.state.skills
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/users'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    setUserLevel(e) {
        e.preventDefault();
        if (this.state.selectedLevel == this.getDefaultGuid()) {
            this.showErorrMessage("لطفا یکی از سطوح را انتخاب نمایید.");
            return;
        }
        this.httpPost("api/v1/user/setuserlevel", {
            userLevelId: this.state.selectedLevel,
            userId: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.state.data.userAccess = data.userAccess;
                this.setState({ selectedLevel: this.getDefaultGuid() });
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    removeUserLevel(userAccessId) {
        this.httpPost("api/v1/user/removeuserlevel", {
            userAccessId: userAccessId,
            userId: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.data.userAccess = data.userAccess;
                    this.setState({ data: this.state.data });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    loadSkillsOptions(inputValue, callback) {
        setTimeout(() => {
            fetch("/api/v1/common/getskills/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.id,
                            label: _record.title
                        }));
                    }
                    callback(items);
                })
        }, 50);
    };
    setSkill(e) {
        this.state.skills = e;
    }
    setCooperationType(e) {
        this.state.data.record.cooperationType = e;
        this.setState({ data: this.state.data });
    }
    newJob() {
        this.state.data.record.jobs.push({
            id: this.uuidv4(),
            title: '',
            year: '',
            organ: '',
            organDesc: ''
        });
        this.setState({ data: this.state.data });
    }
    newEducation() {
        this.state.data.record.educations.push({
            id: this.uuidv4(),
            year: '',
            uni: '',
            field: ''
        });
        this.setState({ data: this.state.data });
    }
    newReward() {
        this.state.data.record.rewards.push({
            id: this.uuidv4(),
            title: '',
            year: '',
            organ: '',
            organDesc: ''
        });
        this.setState({ data: this.state.data });
    }
    removeJob(id) {
        var t = [];
        this.state.data.record.jobs.forEach(f => {
            if (f.id != id) t.push(f);
        });
        this.state.data.record.jobs = t;
        this.setState({ data: this.state.data });
    }
    removeEducation(id) {
        var t = [];
        this.state.data.record.educations.forEach(f => {
            if (f.id != id) t.push(f);
        });
        this.state.data.record.educations = t;
        this.setState({ data: this.state.data });
    }
    removeReward(id) {
        var t = [];
        this.state.data.record.rewards.forEach(f => {
            if (f.id != id) t.push(f);
        });
        this.state.data.record.rewards = t;
        this.setState({ data: this.state.data });
    }
    setJob(id, field, value) {
        this.state.data.record.jobs.forEach(f => {
            if (f.id == id) f[field] = value;
        });
    }
    setEducation(id, field, value) {
        this.state.data.record.educations.forEach(f => {
            if (f.id == id) f[field] = value;
        });
    }
    setReward(id, field, value) {
        this.state.data.record.rewards.forEach(f => {
            if (f.id == id) f[field] = value;
        });
    }
    loadCitiesOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getcities/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(response => {
                let items = [];
                if (response.status == 1) {
                    response.records.map(_record => items.push({
                        value: _record.id,
                        label: _record.name,
                        provinceId: _record.provinceId
                    }));
                }
                callback(items);
            })
        }, 50);
    };
    setLocation(e) {
        this.state.data.record.cityId = e.value;
        this.state.data.record.provinceId = e.provinceId;
    }
    setRole(e) {
        this.state.data.record.role = e;
        this.setState({ data: this.state.data });
    }
    setAffiliateMarketingPlan(e) {
        e.preventDefault();
        if (this.state.selectedAffiliateMarketingPlan == this.getDefaultGuid()) {
            this.showErorrMessage("لطفا یکی از پلن ها را انتخاب نمایید.");
            return;
        }
        this.httpPost("api/v1/user/setaffiliatemarketingplan", {
            planId: this.state.selectedAffiliateMarketingPlan,
            userId: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.data.affiliateMarketingPlanUsers = data.affiliateMarketingPlanUsers;
                    this.setState({ selectedAffiliateMarketingPlan: this.getDefaultGuid() });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <form method="post" onSubmit={e => this.save(e)}>
                                    <div className="card card-bordered card-preview">
                                        <div className="card-inner">
                                            <ul className="nav nav-tabs mt-n3">
                                                <li className="nav-item">
                                                    <a className="nav-link active" data-bs-toggle="tab" href="#info"><em className="icon ni ni-info"></em><span>اطلاعات کاربر</span></a>
                                                </li>
                                                <li className="nav-item" id="UserResumeTab">
                                                    <a className="nav-link" data-bs-toggle="tab" href="#resume"><em className="icon ni ni-info"></em><span>محتوای رزومه</span></a>
                                                </li>
                                                {/*{this.state.data.record.id != this.defaultGuid() && <li className="nav-item">*/}
                                                {/*    <a className="nav-link" data-bs-toggle="tab" href="#modules"><em className="icon ni ni-list-round"></em><span>دسترسی ماژول ها</span></a>*/}
                                                {/*</li>}*/}
                                                {/*{this.state.data.record.id != this.defaultGuid() && <li className="nav-item">*/}
                                                {/*    <a className="nav-link" data-bs-toggle="tab" href="#companies"><em className="icon ni ni-wallet-alt"></em><span>شرکتها</span></a>*/}
                                                {/*</li>}*/}
                                                {this.state.data.record.id != this.defaultGuid() && <li className="nav-item" id="UserResumeTickets">
                                                    <a className="nav-link" data-bs-toggle="tab" href="#tickets"><em className="icon ni ni-wallet-alt"></em><span>پیام های پشتیبانی</span></a>
                                                </li>}
                                                {this.state.data.record.id != this.defaultGuid() && <li className="nav-item" id="UserResumeAff">
                                                    <a className="nav-link" data-bs-toggle="tab" href="#aff"><em className="icon ni ni-wallet-alt"></em><span>همکاری در فروش</span></a>
                                                </li>}
                                            </ul>
                                            <div className="tab-content">
                                                <div className="tab-pane active" id="info">
                                                    <div className="row g-4">
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نام</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control" type="text" defaultValue={this.state.data.record.fname} onChange={e => this.state.data.record.fname = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نام خانوادگی</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control" type="text" defaultValue={this.state.data.record.lname} onChange={e => this.state.data.record.lname = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">کدملی</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control ltr" type="text" defaultValue={this.state.data.record.nationalId} onChange={e => this.state.data.record.nationalId = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">شماره موبایل</label>
                                                                <div className="form-control-wrap">
                                                                    <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.mobile} onChange={e => this.state.data.record.mobile = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">وضعیت</label>
                                                                <div className="form-control-wrap">
                                                                    <select className="form-control" type="text" defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = parseInt(e.target.value)}>
                                                                        <option value='0'>در حال ثبت نام</option>
                                                                        <option value='1'>تایید شده</option>
                                                                        <option value='2'>مسدود شده</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نقش</label>
                                                                <div className="form-control-wrap">
                                                                    <select className="form-control" type="text" defaultValue={this.state.data.record.role} onChange={e => this.setRole(parseInt(e.target.value))}>
                                                                        <option value='1'>مدیریت</option>
                                                                        <option value='2'>کاربر</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.data.record.role === 1 && <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">نقش دوم</label>
                                                                <div className="form-control-wrap">
                                                                    <select className="form-control" type="text" defaultValue={this.state.data.record.role2} onChange={e => this.state.data.record.role2 = parseInt(e.target.value)}>
                                                                        <option value='0'>انتخاب نمایید</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">تیک آبی</label>
                                                                <div className="form-control-wrap">
                                                                    <select className="form-control" type="text" defaultValue={this.state.data.record.blueTick ? "1" : "0"} onChange={e => this.state.data.record.blueTick = e.target.value === "1"}>
                                                                        <option value='1'>فعال</option>
                                                                        <option value='0'>غیرفعال</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">درصد پورسانت مدرس</label>
                                                                <div className="form-control-wrap">
                                                                    <input maxLength="13" className="form-control ltr" type="text" defaultValue={this.state.data.record.commissionPercent} onChange={e => this.state.data.record.commissionPercent = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="form-group">
                                                                <label className="form-label">کلمه عبور</label>
                                                                <div className="form-control-wrap">
                                                                    <input className="form-control" type="password" defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="tab-pane" id="resume">
                                                    <div className="card card-bordered">
                                                        <div className="card-inner">
                                                            <div className="card-head">
                                                                <h5 className="card-title">محتوای رزومه</h5>
                                                            </div>
                                                            <div className="row g-4">
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">استان-شهر</label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.isNull(this.state.data.city) ? null : [{ value: this.state.data.city.id, label: this.state.data.city.provinceNameFa + " - " + this.state.data.city.nameFa }]}
                                                                                isMulti={false}
                                                                                placeholder="انتخاب شهر"
                                                                                defaultOptions
                                                                                loadOptions={this.loadCitiesOptions}
                                                                                onChange={e => this.setLocation(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-6">
                                                                    <div className="form-group">
                                                                        <label className="form-label">سمت</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" maxLength="150" type="text" defaultValue={this.state.data.record.aff} onChange={e => this.state.data.record.aff = e.target.value} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <b><i>راهنما: حسابدار دور کار و مشاور مالی مختص حسابداران با سابقه کار مالیاتی در شرکتهای خدماتی - بازرگانی - پیمانکاری و تولیدی است . در صورتیکه اشراف به امور مالیاتی ندارید حسابدار ثابت در محل را انتخاب کنید</i></b>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نحوه همکاری</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.cooperationType} onChange={e => this.setCooperationType(parseInt(e.target.value))}>
                                                                                <option value="0">انتخاب کنید ...</option>
                                                                                <option value="2">حسابدار ثابت در محل</option>
                                                                                <option value="1">حسابدار دورکار ( پروژه ای - ساعتی )</option>
                                                                                <option value="6">کارآموز حسابداری</option>
                                                                                <option value="3">مشاور مالی </option>
                                                                                <option value="4">فروش و بازاریابی</option>
                                                                                <option value="5">برنامه نویسی</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">وضعیت رزومه</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.resumeDisplayStatus} onChange={e => this.state.data.record.resumeDisplayStatus = parseInt(e.target.value)}>
                                                                                <option value="1">عدم نمایش رزومه</option>
                                                                                <option value="2">نمایش برای اعضا</option>
                                                                                <option value="3">نمایش عمومی</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">جنسیت</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.gender} onChange={e => this.state.data.record.gender = parseInt(e.target.value)}>
                                                                                <option value="0">انتخاب کنید</option>
                                                                                <option value="1">خانم</option>
                                                                                <option value="2">آقا</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">تحصیلات</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.education} onChange={e => this.state.data.record.education = parseInt(e.target.value)}>
                                                                                <option value="0">انتخاب کنید</option>
                                                                                <option value="1">سیکل</option>
                                                                                <option value="2">دیپلم</option>
                                                                                <option value="3">کارشناسی</option>
                                                                                <option value="4">کارشناسی ارشد</option>
                                                                                <option value="5">دکتری</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <label className="form-label">انتخاب مهارتها و تخصص ها</label>
                                                                        <div className="form-control-wrap">
                                                                            <SelectAsync
                                                                                defaultValue={this.state.skills}
                                                                                isMulti={true}
                                                                                placeholder="مهارتها و تخصص ها"
                                                                                defaultOptions
                                                                                loadOptions={this.loadSkillsOptions}
                                                                                onChange={e => this.setSkill(e)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">مشاوره آنلاین</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.counselingOnline} onChange={e => this.state.data.record.counselingOnline = parseInt(e.target.value)}>
                                                                                <option value="0">غیرفعال</option>
                                                                                <option value="1">فعال</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نرخ مشاوره آنلاین (ریال)</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" maxLength="150" type="text" defaultValue={this.state.data.record.counselingOnlinePrice} onChange={e => this.state.data.record.counselingOnlinePrice = parseInt(e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">مشاوره تلفنی</label>
                                                                        <div className="form-control-wrap">
                                                                            <select className="form-control" defaultValue={this.state.data.record.counselingPhone} onChange={e => this.state.data.record.counselingPhone = parseInt(e.target.value)}>
                                                                                <option value="0">غیرفعال</option>
                                                                                <option value="1">فعال</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نرخ مشاوره تلفنی (15دقیقه)</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" maxLength="150" type="text" defaultValue={this.state.data.record.counselingPhonePrice} onChange={e => this.state.data.record.counselingPhonePrice = parseInt(e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نرخ مشاوره تلفنی (30 دقیقه)</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" maxLength="150" type="text" defaultValue={this.state.data.record.counselingPhonePrice2} onChange={e => this.state.data.record.counselingPhonePrice2 = parseInt(e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                {this.state.data.record.cooperationType !== 2 && <div className="col-lg-3">
                                                                    <div className="form-group">
                                                                        <label className="form-label">نرخ مشاوره تلفنی (45دقیقه)</label>
                                                                        <div className="form-control-wrap">
                                                                            <input className="form-control" maxLength="150" type="text" defaultValue={this.state.data.record.counselingPhonePrice3} onChange={e => this.state.data.record.counselingPhonePrice3 = parseInt(e.target.value)} />
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <label className="form-label">متن درباره من</label>
                                                                        <div className="form-control-wrap">
                                                                            <textarea className="form-control" defaultValue={this.state.data.record.aboutMe} onChange={e => this.state.data.record.aboutMe = e.target.value}></textarea>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card card-bordered mt-4">
                                                        <div className="card-inner">
                                                            <div className="card-head">
                                                                <h5 className="card-title">سوابق کاری و شغلی</h5>
                                                            </div>
                                                            <div className="row g-4">
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <div className="form-control-wrap">
                                                                            {this.state.data.record.jobs.map(item => <div style={{ "margin-top": "5px", "gap": "16px", "display": "flex", "flex-direction": "column", "border": "solid 1px #dbdfea", "padding": "12px" }}>
                                                                                <input type="text" className="form-control" placeholder="عنوان" defaultValue={item.title} onChange={e => this.setJob(item.id, 'title', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="سال" defaultValue={item.year} onChange={e => this.setJob(item.id, 'year', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="شرکت/سازمان" defaultValue={item.organ} onChange={e => this.setJob(item.id, 'organ', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="مختصری از فعالیت شما در آن شرکت" defaultValue={item.organDesc} onChange={e => this.setJob(item.id, 'organDesc', e.target.value)} />
                                                                                <a style={{ "width": "80px" }} className="hand btn btn-icon btn-danger" onClick={e => this.removeJob(item.id)}><em className="icon ni ni-trash"></em> حذف</a>
                                                                            </div>)}
                                                                            <a className="hand" onClick={e => this.newJob()} style={{ "margin-top": "15px", "text-align": "center", "display": "block" }}><em className="icon ni ni-plus"></em> افزودن سابقه کاری و شغلی جدید</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card card-bordered mt-4">
                                                        <div className="card-inner">
                                                            <div className="card-head">
                                                                <h5 className="card-title">سوابق تحصیلی</h5>
                                                            </div>
                                                            <div className="row g-4">
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <div className="form-control-wrap">
                                                                            {this.state.data.record.educations.map(item => <div style={{ "margin-top": "5px", "gap": "16px", "display": "flex", "flex-direction": "column", "border": "solid 1px #dbdfea", "padding": "12px" }}>
                                                                                <input type="text" className="form-control" placeholder="دانشگاه" defaultValue={item.uni} onChange={e => this.setEducation(item.id, 'uni', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="سال" defaultValue={item.year} onChange={e => this.setEducation(item.id, 'year', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="رشته" defaultValue={item.field} onChange={e => this.setEducation(item.id, 'field', e.target.value)} />
                                                                                <a style={{ "width": "80px" }} className="hand btn btn-icon btn-danger" onClick={e => this.removeEducation(item.id)}><em className="icon ni ni-trash"></em> حذف</a>
                                                                            </div>)}
                                                                            <a className="hand" onClick={e => this.newEducation()} style={{ "margin-top": "15px", "text-align": "center", "display": "block" }}><em className="icon ni ni-plus"></em>افزودن سابفه تحصیلی جدید</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card card-bordered mt-4">
                                                        <div className="card-inner">
                                                            <div className="card-head">
                                                                <h5 className="card-title">پروژه ها و فعالیتهای علمی تحقیقاتی</h5>
                                                            </div>
                                                            <div className="row g-4">
                                                                <div className="col-lg-12">
                                                                    <div className="form-group">
                                                                        <div className="form-control-wrap">
                                                                            {this.state.data.record.rewards.map(item => <div style={{ "margin-top": "5px", "gap": "16px", "display": "flex", "flex-direction": "column", "border": "solid 1px #dbdfea", "padding": "12px" }}>
                                                                                <input type="text" className="form-control" placeholder="نام پروژه" defaultValue={item.title} onChange={e => this.setReward(item.id, 'title', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="سال اجرای پروژه" defaultValue={item.year} onChange={e => this.setReward(item.id, 'year', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="نام شرکت/سازمان" defaultValue={item.organ} onChange={e => this.setReward(item.id, 'organ', e.target.value)} />
                                                                                <input type="text" className="form-control" placeholder="موضوع فعالیت شرکت" defaultValue={item.organDesc} onChange={e => this.setReward(item.id, 'organDesc', e.target.value)} />
                                                                                <a style={{ "width": "80px" }} className="hand btn btn-icon btn-danger" onClick={e => this.removeReward(item.id)}><em className="icon ni ni-trash"></em> حذف</a>
                                                                            </div>)}
                                                                            <a className="hand" onClick={e => this.newReward()} style={{ "margin-top": "15px", "text-align": "center", "display": "block" }}><em className="icon ni ni-plus"></em>افزودن پروژه ها و فعالیتهای علمی تحقیقاتی جدید</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*{this.state.data.record.id != this.defaultGuid() && <div className="tab-pane" id="modules">*/}
                                                {/*    <div className="card-inner p-0">*/}
                                                {/*        <div className="nk-tb-list nk-tb-ulist">*/}
                                                {/*            <div className="nk-tb-item nk-tb-head">*/}
                                                {/*                <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>*/}
                                                {/*                <div className="nk-tb-col"><span className="sub-text">ماژول</span></div>*/}
                                                {/*                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">ثبت</span></div>*/}
                                                {/*                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">انقضا</span></div>*/}
                                                {/*            </div>*/}
                                                {/*            {this.state.data.userModules.map((record, index) =>*/}
                                                {/*                <div className="nk-tb-item">*/}
                                                {/*                    <div className="nk-tb-col">*/}
                                                {/*                        <span className="sub-text">{(index+1)}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                    <div className="nk-tb-col">*/}
                                                {/*                        <span className="sub-text">{record.systemModuleName}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                    <div className="nk-tb-col tb-col-md">*/}
                                                {/*                        <span className="sub-text text-center">{record.registerDate}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                    <div className="nk-tb-col tb-col-md">*/}
                                                {/*                        <span className="sub-text text-center">{record.expireDate}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                </div>*/}
                                                {/*            )}*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {/*</div>}*/}
                                                {/*{this.state.data.record.id != this.defaultGuid() && <div className="tab-pane" id="companies">*/}
                                                {/*    <div className="card-inner p-0">*/}
                                                {/*        <div className="nk-tb-list nk-tb-ulist">*/}
                                                {/*            <div className="nk-tb-item nk-tb-head">*/}
                                                {/*                <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>*/}
                                                {/*                <div className="nk-tb-col"><span className="sub-text">نام شرکت</span></div>*/}
                                                {/*                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">شناسه ملی</span></div>*/}
                                                {/*            </div>*/}
                                                {/*            {this.state.data.companies.map((record, index) =>*/}
                                                {/*                <div className="nk-tb-item">*/}
                                                {/*                    <div className="nk-tb-col">*/}
                                                {/*                        <span className="sub-text">{(index + 1)}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                    <div className="nk-tb-col">*/}
                                                {/*                        <span className="sub-text">{record.name}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                    <div className="nk-tb-col tb-col-md">*/}
                                                {/*                        <span className="sub-text text-center">{record.nationalId}</span>*/}
                                                {/*                    </div>*/}
                                                {/*                </div>*/}
                                                {/*            )}*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {/*</div>}*/}
                                                {this.state.data.record.id != this.defaultGuid() && <div className="tab-pane" id="tickets">
                                                    <div className="card-inner p-0">
                                                        <div className="nk-tb-list nk-tb-ulist">
                                                            <div className="nk-tb-item nk-tb-head">
                                                                <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                                                <div className="nk-tb-col"><span className="sub-text">شماره تیکت</span></div>
                                                                <div className="nk-tb-col"><span className="sub-text">موضوع</span></div>
                                                                <div className="nk-tb-col"><span className="sub-text">تاریخ</span></div>
                                                            </div>
                                                            {this.state.data.tickets.map((record, index) =>
                                                                <div className="nk-tb-item">
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{(index + 1)}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{record.number}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{record.subject}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{record.date}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>}

                                                {this.state.data.record.id != this.defaultGuid() && <div className="tab-pane" id="aff">
                                                    <div className="row g-4 mb-4">
                                                        <div className="col-lg-9">
                                                            <div className="form-group">
                                                                <label className="form-label">پلن</label>
                                                                <div className="form-control-wrap">
                                                                    <select className="form-control" type="text" defaultValue={this.state.selectedAffiliateMarketingPlan} onChange={e => this.state.selectedAffiliateMarketingPlan = e.target.value}>
                                                                        <option value={this.getDefaultGuid()}>انتخاب کنید ...</option>
                                                                        {this.state.data.affiliateMarketingPlan.map(u => <option value={u.id}>{u.title}</option>)}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3" style={{ "display": "flex", "align-items": "end" }}>
                                                            <div className="form-group">
                                                                <button onClick={e => this.setAffiliateMarketingPlan(e)} className="btn btn-sm btn-primary">افزودن / تمدید</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-inner p-0">
                                                        <div className="nk-tb-list nk-tb-ulist">
                                                            <div className="nk-tb-item nk-tb-head">
                                                                <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                                                <div className="nk-tb-col"><span className="sub-text">عنوان</span></div>
                                                                <div className="nk-tb-col"><span className="sub-text">کد</span></div>
                                                            </div>
                                                            {this.state.data.affiliateMarketingPlanUsers.map((record, index) =>
                                                                <div className="nk-tb-item">
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{(index + 1)}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{record.title}</span>
                                                                    </div>
                                                                    <div className="nk-tb-col">
                                                                        <span className="sub-text">{record.code}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}